import React from "react";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import { Box, Grid, Button } from "@material-ui/core";
import Linkref from "@material-ui/core/Link";
import { Link } from "react-router-dom";
import LobConstants from "../../constants/LobConstants";
import SearchIcon from "@material-ui/icons/Search";
import FilterListIcon from "@material-ui/icons/FilterList";
import useStyles from "../../themes/makeStyles";
import Hidden from "@material-ui/core/Hidden";
import StyledMenu from "../Menu/StyledMenu";
import Filter from "../../assets/filter.png";
import clsx from "clsx";
import Tooltip from "@material-ui/core/Tooltip";
import { useHistory } from "react-router-dom";
import SvgIcon from "@material-ui/core/SvgIcon";
function FilterSVG(props) {
  return (
    <SvgIcon {...props}>
      <g
        id="icon_role_18"
        dataname="icon_role – 18"
        clipPath="url(#clip-icon_role_18)"
      >
        <path
          id="Path_204"
          dataname="Path 204"
          d="M202.825,495.25h22.831l-8.369,12.269v7.719l-5.687,2.275v-9.994Z"
          transform="translate(-202.3 -494.312)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.3"
        />
      </g>
    </SvgIcon>
  );
}

function Sort(props) {
  return (
    <SvgIcon {...props}>
      <g>
        <g>
          <g>
            <path d="m496.1,138.3l-120.4-120.4c-7.9-7.9-20.6-7.9-28.5-7.10543e-15l-120.3,120.4c-7.9,7.9-7.9,20.6 0,28.5 7.9,7.9 20.6,7.9 28.5,0l85.7-85.7v352.8c0,11.3 9.1,20.4 20.4,20.4 11.3,0 20.4-9.1 20.4-20.4v-352.8l85.7,85.7c7.9,7.9 20.6,7.9 28.5,0 7.9-7.8 7.9-20.6 5.68434e-14-28.5z" />
            <path d="m287.1,347.2c-7.9-7.9-20.6-7.9-28.5,0l-85.7,85.7v-352.8c0-11.3-9.1-20.4-20.4-20.4-11.3,0-20.4,9.1-20.4,20.4v352.8l-85.7-85.7c-7.9-7.9-20.6-7.9-28.5,0-7.9,7.9-7.9,20.6 0,28.5l120.4,120.4c7.9,7.9 20.6,7.9 28.5,0l120.4-120.4c7.8-7.9 7.8-20.7-0.1-28.5l0,0z" />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}
export default function PageHeadingListView(props) {
  /*
  signature:input title and path to navigate returns heading bar
  Description: this is used to display heading bar in every page with breadcrumb
  Purpose: to display heading and also display breadcrumb for path  
  */
  const history = useHistory();
  const classes = useStyles();
  return (
    <Box py={3}>
      <SimpleBreadcrumbs path={props.headingpath} />
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Grid item>
          {/* <h2 className={classes.mainHeading}> {props.headingtitle}</h2> */}
        </Grid>
        <Grid item>
          <Grid container justify="flex-end" alignItems="center" spacing={1}>
            <Hidden only={["sm", "md", "lg", "xl"]}>
              {props.fromContractMaster && (
                <Grid item>
                  <Box my={1}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={props.downloadContractMasterData}
                      disbled={props.disabledContractDownloadBtn}
                      className={classes.subTextButton}
                      mr={1}
                    >
                      Download Contract Data
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        history.push({
                          pathname: `/${LobConstants.LOB}/masters/contractMaster/uploadData`,
                        });
                      }}
                      className={classes.subTextButton}
                    >
                      Upload Contract Data
                    </Button>
                    {/* <Link
                    style={{ textDecoration: "none" }}
                    to={process.env.PUBLIC_URL + "/ContractHeader.xlsx"}
                    target="_blank"
                    download
                    className={clsx(
                      classes.subTextButton,
                      classes.primaryColor,
                      "mr-1"
                    )}
                  >
                    Download Wagon Details Template
                  </Link>  */}
                  </Box>
                </Grid>
              )}
              {props.fromStationMaster && (
                <Grid item>
                  <Box my={1}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={props.downloadStationMasterData}
                      disbled={false}
                      className={classes.subTextButton}
                      mr={1}
                    >
                      Download Station Data
                    </Button>
                    {/* <Link
                    style={{ textDecoration: "none" }}
                    to={process.env.PUBLIC_URL + "/ContractHeader.xlsx"}
                    target="_blank"
                    download
                    className={clsx(
                      classes.subTextButton,
                      classes.primaryColor,
                      "mr-1"
                    )}
                  >
                    Download Wagon Details Template
                  </Link>  */}
                  </Box>
                </Grid>
              )}
              <Grid item>
                <Tooltip title="Sort" arrow>
                  <Box className={classes.searchIconBorder}>
                    <FilterListIcon
                      className={classes.searchIconXs}
                      onClick={props.buttonhandleFilterClick}
                      aria-controls="customized-menu"
                      aria-haspopup="true"
                    />
                    <StyledMenu
                      id="customized-menu"
                      anchorEl={props.filterliststate}
                      keepMounted
                      open={Boolean(props.filterliststate)}
                      onClick={props.handlefilterclose}
                    >
                      {props.filterlist}
                    </StyledMenu>
                  </Box>
                </Tooltip>
              </Grid>
              <Grid item>
                <Tooltip title="Filter" arrow>
                  <Box className={clsx(classes.searchIconBorder)}>
                    <img
                      src={Filter}
                      className={classes.searchIconXs}
                      onClick={props.buttonhandleSearchClick}
                    />
                  </Box>
                </Tooltip>
              </Grid>
              <Grid item>
                <Tooltip title="Search" arrow>
                  <Box className={classes.searchIconBorder}>
                    <SearchIcon
                      className={classes.searchIconXs}
                      onClick={props.buttonhandleSearchFilterClick}
                    />
                  </Box>
                </Tooltip>
              </Grid>
            </Hidden>
            <Hidden only="xs">
              {props.fromContractMaster && (
                <>
                  <Grid item>
                    <Box my={1}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={props.downloadContractMasterData}
                        className={classes.subTextButton}
                        mr={1}
                      >
                        Download Contract Data
                      </Button>
                    </Box>
                  </Grid>
                  <Grid item>
                    <Box py={1}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          history.push({
                            pathname: `/${LobConstants.LOB}/masters/contractMaster/uploadData`,
                          });
                        }}
                        className={classes.subTextButton}
                      >
                        Upload Contract Data
                      </Button>

                      {/* <Link
                    style={{ textDecoration: "none" }}
                    to={process.env.PUBLIC_URL + "/ContractHeader.xlsx"}
                    target="_blank"
                    download
                    className={clsx(
                      classes.subTextButton,
                      classes.primaryColor,
                      "mr-1"
                    )}
                  >
                    Download Wagon Details Template
                  </Link>  */}
                    </Box>
                  </Grid>
                </>
              )}
              {props.fromStationMaster && (
                <Grid item>
                  <Box my={1}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={props.downloadStationMasterData}
                      disbled={false}
                      className={classes.subTextButton}
                      mr={1}
                    >
                      Download Station Data
                    </Button>
                    {/* <Link
                    style={{ textDecoration: "none" }}
                    to={process.env.PUBLIC_URL + "/ContractHeader.xlsx"}
                    target="_blank"
                    download
                    className={clsx(
                      classes.subTextButton,
                      classes.primaryColor,
                      "mr-1"
                    )}
                  >
                    Download Wagon Details Template
                  </Link>  */}
                  </Box>
                </Grid>
              )}
              {props.fromWagonMaster && (
                <Grid item>
                  <Box my={1}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        history.push({
                          pathname: `/${LobConstants.LOB}/masters/wagonmaster/uploadData`,
                        });
                      }}
                      className={classes.subTextButton}
                    >
                      Upload Wagon Data
                    </Button>
                  </Box>
                </Grid>
              )}
              <Grid item>
                <Tooltip title="submit" arrow>
                  <Button
                    variant="contained"
                    color="primary"
                    aria-controls="customized-menu"
                    aria-haspopup="true"
                    onClick={props.buttonhandleFilterClick}
                    className={classes.subTextButton}
                  >
                    <FilterListIcon
                      className={classes.searchIcon}
                      onClick={props.buttonhandleFilterClick}
                      aria-controls="customized-menu"
                      aria-haspopup="true"
                    />
                  </Button>
                </Tooltip>
                <StyledMenu
                  id="customized-menu"
                  anchorEl={props.filterliststate}
                  keepMounted
                  open={Boolean(props.filterliststate)}
                  // onClose={props.handlefilterclose}
                  onClick={props.handlefilterclose}
                >
                  {props.filterlist}
                </StyledMenu>
              </Grid>
              <Grid item>
                <Tooltip title="Filter" arrow>
                  <Button
                    variant="contained"
                    color="primary"
                    id="SearchIcon"
                    className={clsx(classes.subTextButton, "btnMinWidth")}
                    onClick={props.buttonhandleSearchClick}
                  >
                    <FilterSVG className={classes.searchIcon} />
                  </Button>
                </Tooltip>
              </Grid>
              <Grid item>
                <Tooltip title="Search" arrow>
                  <Button
                    variant="contained"
                    color="primary"
                    id="SearchIcon"
                    className={classes.subTextButton}
                    onClick={props.buttonhandleSearchFilterClick}
                  >
                    <SearchIcon className={classes.searchIcon} />
                  </Button>
                </Tooltip>
              </Grid>
            </Hidden>
            <Grid item>
              <Link style={{ textDecoration: "none" }} to={props.buttonpath}>
                <Box>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.subTextButton}
                  >
                    {props.buttontitle}
                  </Button>
                </Box>
              </Link>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

function SimpleBreadcrumbs(props) {
  const subPath = props.path.split("/");
  //console.log(subPath);
  let path = "";
  const classes = useStyles();
  return (
    <Breadcrumbs aria-label="breadcrumb" className={classes.mainBreadcrumbs}>
      {subPath.map((sub, index) => {
        path = path + sub;
        if (index + 1 !== subPath.length) {
          if (sub !== LobConstants.LOB) {
            return (
              <Linkref
                key={index}
                href={sub}
                className={classes.mainBreadcrumbs}
              >
                {sub}
              </Linkref>
            );
          }
        } else {
          return (
            <Typography
              key={index}
              color="textPrimary"
              className={classes.childBreadcrumbs}
            >
              {sub}
            </Typography>
          );
        }
      })}
    </Breadcrumbs>
  );
}
